export default __webpack_public_path__ + "static/media/home-create.1ac3f176.svg";